export default function GlobalAppPlugin(app) {

    let global = window || global;

    global.app = app;

}
